import React, { useState, useRef, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { AddGoiVayDesktopBtn } from "./AddGoiVayDesktopBtn";
import { updateDataSearch } from "actions/QuanLyGoiVay";

export const TableDanhSach = ({ dataDanhSach, onSearch, phanQuyen }) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchGoiVay);
  const handlePageChange = (iPageIndex) => {
    dataSearch.iPageIndex = iPageIndex;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        iPageIndex: iPageIndex,
      })
    );
    onSearch();
  };
  return (
    <>
      <div
        className="card mb-3 border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          {(phanQuyen.quanlygoivay == false ||
            phanQuyen.quanlygoivay_themmoigoivay) && (
            <>
              <div className="mb-1">
                <AddGoiVayDesktopBtn data={""} onSearch={onSearch} />
              </div>
            </>
          )}
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile sticky-table-bh1 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers"  style={{top:"15.2rem"}}>
                  <div className="custom-table-header flex-basis-5 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {dataDanhSach.iTotal} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="left-center">Mã gói vay</p>
                  </div>
                  <div className="custom-table-header flex-basis-30 flex-basis-30-sm">
                    <p className="tab-header  left-center">Tên gói vay</p>
                  </div>
                  {phanQuyen.quytrinhpheduyet_danhsach  == true && (
                    <>
                      <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                        <p className="tab-header  left-center">Loại gói vay</p>
                      </div>
                    </>
                  )}

                  <div className="custom-table-header flex-basis-20 flex-basis-20-sm">
                    <p className="tab-header  left-center">Hạn mức gói vay</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="tab-header text-center">Thao tác</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  {typeof dataDanhSach.List != "undefined" &&
                    dataDanhSach.List.length > 0 && (
                      <ContentTable
                        dataDanhSach={dataDanhSach}
                        onSearch={onSearch}
                        phanQuyen={phanQuyen}
                      />
                    )}
                  {typeof dataDanhSach.List === "undefined" ||
                    (dataDanhSach.List.length === 0 && (
                      <div>Không có dữ liệu</div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-1 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <span className="color7">
                {dataDanhSach.iTotal === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearch.iPageIndex - 1) * dataSearch.iPageSize + 1} -{" "}
                    {Math.min(
                      dataSearch.iPageIndex * dataSearch.iPageSize,
                      dataDanhSach.iTotal
                    )}{" "}
                    / Tổng số {dataDanhSach.iTotal}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (dataDanhSach.iTotal === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.iPageIndex}
                    itemsCountPerPage={dataSearch.iPageSize}
                    totalItemsCount={dataDanhSach.iTotal}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
